export default {
  register: {
    general: {
      title: {
        register: 'Sign Up',
        login: 'Log In',
        alt: 'Already have an account?'
      }
    },
    title: 'Sign Up',
    or: 'or',
    google: 'Sign up with Google',
    github: 'Sign up with GitHub',
    clever: 'Sign up with Clever',
    submit: 'Sign up',
    invite: {
      academy_invite: 'Welcome to Posit Academy!',
      account_invite: 'You have been invited to join an account on Posit by {email}.',
      application_invite: 'An application on shinyapps.io has been shared with you by {email}.',
      space_invite: 'You have been invited to join a space on Posit Cloud by {email}.',
      resolution: 'Please log in or sign up to continue.'
    },
    login: 'Already have an account? <a href={- url}>Log In</a>',
    loginTitle: 'Log In',
    loginAltText: 'Already have an account?',
    password: {
      placeholder: 'Password',
      strength: 'Strength',
      strongPassword: 'You must enter a sufficiently strong password.',
      useUpperLowerLetters: 'Use upper and lower case letters',
      useNumbers: 'Use numbers',
      useSpecialCharacters: 'Use special characters',
      useLonger: 'Longer is stronger',
      infoLabel: 'Password info'
    },
    errors: {
      email_not_unique: 'Sign Up failed - this email was used previously to create an account. Please log in instead.',
      invalid_request: 'Sign Up failed - no recaptcha token was used.',
      invitation_not_found: 'Sign Up failed - the invitation code used does not exist.',
      invitation_sso_enabled: 'Sign Up failed - please authenticate with your SSO identity provider.',
      invite_code_expired: 'Sign Up failed - your invitation has expired.',
      invite_code_used: 'Sign Up failed - your invitation was already accepted.',
      local_authentication_forbidden: 'Sign Up failed - local authentication is forbidden.',
      recaptcha_invalid_token: 'Sign Up failed - the recaptcha token is invalid.',
      recaptcha_low_score: 'Sign Up failed - the recaptcha has a low score.'
    },
    placeholder: {
      email: 'Email',
      first_name: 'First name',
      last_name: 'Last name',
    },
    sign_up_agreement: 'By signing up, you agree to the <a href="https://posit.co/about/posit-service-terms-of-use/" target="_blank" rel="noopener noreferrer">Posit Service Terms of Use</a> and <a href="https://posit.co/about/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
    sso: {
      details: {
        dedicated: 'Access to Posit is provided via {name}.'
      },
      submit: 'Sign up via {name}'
    }
  },
};
